import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injectable } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { SchedulerMainComponent } from './pages/scheduler-main/scheduler-main.component';
import { LayoutControlCalendarComponent } from './components/layout-control-calendar/layout-control-calendar.component';
import { CalendarHeaderComponent } from './components/calendar-header/calendar-header.component';
import { CalendarMonthComponent } from './components/calendar-month/calendar-month.component';
import { CalendarWeekComponent } from './components/calendar-week/calendar-week.component';
import { SchedulerFooterComponent } from './components/scheduler-footer/scheduler-footer.component';
import { SchedulerModalComponent } from './components/scheduler-modal/scheduler-modal.component';

import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import * as Hammer from 'hammerjs';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { HammerModule } from '@angular/platform-browser';
import { SchedulerAgendaComponent } from './components/scheduler-agenda/scheduler-agenda.component';
import { NormalAgendaComponent } from './components/agenda/normal-agenda/normal-agenda.component';
import { FlaggedAgendaComponent } from './components/agenda/flagged-agenda/flagged-agenda.component';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { SchedulerNoAuthComponent } from './pages/scheduler-no-auth/scheduler-no-auth.component';
import { DocumentMetadataComponent } from './components/document-metadata/document-metadata.component';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';
import { EventDetailsComponent } from './components/event-details/event-details.component';

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  } as any;
}

@NgModule({
  declarations: [
    AppComponent,
    SchedulerMainComponent,
    LayoutControlCalendarComponent,
    CalendarHeaderComponent,
    CalendarMonthComponent,
    CalendarWeekComponent,
    SchedulerFooterComponent,
    SchedulerModalComponent,
    SchedulerAgendaComponent,
    NormalAgendaComponent,
    FlaggedAgendaComponent,
    SchedulerNoAuthComponent,
    DocumentMetadataComponent,
    ActionButtonsComponent,
    EventDetailsComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,

    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    HammerModule], providers: [
      {
        provide: HAMMER_GESTURE_CONFIG,
        useClass: HammerConfig,
      },
      { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
      provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule { }
